"use client";

import RefundPolicyView from "@/views/RefundPolicy";

export default function RefundPolicyPage() {
  return <RefundPolicyView />;
}
